import SwiperCore from 'swiper';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
    Button,
    Flex,
    pxToRem,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import * as S from './RecentlyViewed.style';
import { ArrowLeftLine, ArrowRightLine } from '@archipro-design/icons';
import cx from 'classnames';
import { RecentlyViewedTiles } from './RecentlyViewedTiles';
import type { RecentlyViewedQuery } from 'generated/graphql';
import type { CategoryTypes } from '../../type';
import { getSlideSize } from './util/get-slide-size';
interface RecentlyViewedProps {
    recentlyViewed: RecentlyViewedQuery['getRecentlyViewedDirectoryItem'];
    slidesPerView?: number;
    type?: CategoryTypes;
}

SwiperCore.use([Navigation]);
export const RecentlyViewed = (props: RecentlyViewedProps) => {
    const { desktop } = useAppDisplayModeContext();
    const { css } = useStyles({
        hasLeftPadding:
            props?.type &&
            (props.type === 'products' || props.type === 'professionals'),
        slideSize: !desktop ? getSlideSize(props.type) : undefined,
        sectionTopMargin: props.type === 'professionals' ? pxToRem(12) : '0',
        titleBottomSpacingMobile:
            props.type === 'professionals' ? pxToRem(1) : pxToRem(19),
    });

    const { recentlyViewed, slidesPerView = 3 } = props;
    if (!recentlyViewed || recentlyViewed.length === 0) return null;
    return (
        <Flex hAlign="start" column className={css(S.RecentlyViewedWrapper)}>
            <div className={css(S.RecentlyViewedText)}>Recently Viewed</div>
            <div className={css(S.RecentlyViewedSliderWrapper)}>
                <Swiper
                    spaceBetween={desktop ? 0 : 6}
                    slidesPerView={!desktop ? 'auto' : slidesPerView}
                    slidesPerGroup={!desktop ? undefined : slidesPerView}
                    navigation={{
                        nextEl: '.slider-button-next',
                        prevEl: '.slider-button-prev',
                    }}
                    allowSlideNext
                    allowSlidePrev
                    allowTouchMove
                >
                    {recentlyViewed.map((recentlyViewedItem, i) => (
                        <SwiperSlide
                            key={i}
                            className={css(S.RecentlyViewedSlider)}
                        >
                            <RecentlyViewedTiles
                                recentlyViewedItem={recentlyViewedItem}
                            />
                        </SwiperSlide>
                    ))}
                    {recentlyViewed.length > slidesPerView && (
                        <div
                            className={cx(
                                css(S.RecentlyViewedSliderControls),
                                'swiper-pagination'
                            )}
                        >
                            <Button
                                icon={<ArrowLeftLine />}
                                color="primary"
                                transparent={true}
                                size={24}
                                variables={{ buttonPadding: 4 }}
                                className={'slider-button-prev'}
                            />
                            <Button
                                icon={<ArrowRightLine size="1x" />}
                                color="primary"
                                transparent={true}
                                size={24}
                                variables={{ buttonPadding: 4 }}
                                className={'slider-button-next'}
                            />
                        </div>
                    )}
                </Swiper>
            </div>
        </Flex>
    );
};
